import { Action } from '@ngrx/store';

import { BibliographicResource } from '®shared/bibliographic-resource';

export enum ResourceActionTypes {
  FETCH_RESOURCE = '[Resource] Fetch resource by ID',
  FETCH_RESOURCE_SUCCESS = '[Resource] Fetch resource by ID Success',
  FETCH_RESOURCE_FAILED = '[Resource] Fetch resource by ID Failed',
  UPDATE_RESOURCE = '[Resource] Update resource',
  UPDATE_RESOURCE_SUCCESS = '[Resource] Update resource success',
  UPDATE_RESOURCE_FAILED = '[Resource] Update resource failed',
}

export interface ResourcePayload {
  resourceId: string;
}

export interface ResourceDataPayload extends ResourcePayload {
  bibliographicResourceData: BibliographicResource;
}

export interface ResourceErrorPayload extends ResourcePayload {
  error: unknown;
}

export class FetchBibliographicResourceAction implements Action {
  readonly type = ResourceActionTypes.FETCH_RESOURCE;

  constructor(public payload: ResourcePayload) {}
}

export class FetchBibliographicResourceSuccessAction implements Action {
  readonly type = ResourceActionTypes.FETCH_RESOURCE_SUCCESS;

  constructor(public payload: ResourceDataPayload) {}
}

export class FetchBibliographicResourceFailedAction implements Action {
  readonly type = ResourceActionTypes.FETCH_RESOURCE_FAILED;

  constructor(public payload: ResourceErrorPayload) {}
}

export class UpdateBibliographicResourceAction implements Action {
  readonly type = ResourceActionTypes.UPDATE_RESOURCE;

  constructor(
    public payload: { bibliographicResource: BibliographicResource },
  ) {}
}

export class UpdateBibliographicResourceSuccessAction implements Action {
  readonly type = ResourceActionTypes.UPDATE_RESOURCE_SUCCESS;

  constructor(
    public payload: { bibliographicResource: BibliographicResource },
  ) {}
}

export class UpdateBibliographicResourceFailedAction implements Action {
  readonly type = ResourceActionTypes.UPDATE_RESOURCE_FAILED;

  constructor(public payload: { error: unknown }) {}
}

export type ResourceAction =
  | FetchBibliographicResourceAction
  | FetchBibliographicResourceSuccessAction
  | FetchBibliographicResourceFailedAction
  | UpdateBibliographicResourceAction
  | UpdateBibliographicResourceSuccessAction
  | UpdateBibliographicResourceFailedAction;
